import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const clientApi = axios.create({ baseURL: BASE });

clientApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("hm_client_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default clientApi;
